
  <app-toast></app-toast>
  <router-outlet></router-outlet>
  <!-- Env footer -->
  <app-environment></app-environment>

  <ng-container *ngIf="cartService.visible$ | async">

    <!-- alors je veux charger ce composant (lazyload) sinon je ne veux pas qui soit loadé -->
    <app-add-to-cart
      [show]="cartService.visible$ | async"
      [product]="(cartService.product$ | async)!"
      [s_isPageVin]="cartService.s_isPageVin()"
    >
    </app-add-to-cart>
  </ng-container>

  <ng-container *ngIf="wishlistService.visible$ | async">
    <app-add-to-wishlist [show]="wishlistService.visible$ | async"
                         [product]="(wishlistService.product$ | async)!">
    </app-add-to-wishlist>
  </ng-container>

